import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';

Sentry.init({
  dsn: "https://a67cdab4551b0157a629c038871ccc23@o4510777301925888.ingest.de.sentry.io/4511293004972112",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // An aborted request is the browser obeying us - a screen unmounted, the user
  // navigated away mid-fetch - not a fault to investigate. Left unfiltered it
  // arrives as an unhandled rejection with no stack trace (CARVIS-FRONT-6) and
  // buries the real errors.
  ignoreErrors: [
    "AbortError",
    "The user aborted a request",
    "signal timed out",
    "TimeoutError: signal timed out",
    // Scanner de liens Outlook (Safe Links) qui ouvre les liens des e-mails.
    /Object Not Found Matching Id/,
  ],
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
